var React = require('react');

function DocumenticonInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M30 2H15C11.134 2 8 5.13401 8 9V42C8 44.2091 9.79086 46 12 46H36C38.2091 46 40 44.2091 40 42V11.5652M30 2V2C31.2836 2 32.5177 2.4952 33.4453 3.38245L38.6176 8.32984C39.5006 9.17446 40 10.3433 40 11.5652V11.5652M30 2V7.56522C30 9.77436 31.7909 11.5652 34 11.5652H40","stroke":"#FF6A3C","strokeWidth":"3","key":0}),React.createElement("rect",{"x":"16","y":"19","width":"16","height":"6","rx":"3","fill":"#FF6A3C","stroke":"#FF6A3C","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M16 37L32 37","stroke":"#FF6A3C","strokeWidth":"3","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M16 31L32 31","stroke":"#FF6A3C","strokeWidth":"3","strokeLinecap":"round","key":3})]);
}

DocumenticonInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = DocumenticonInline;

DocumenticonInline.default = DocumenticonInline;
